module.exports = __webpack_public_path__ + "static/brittany-kleszynski-dvm-veterinary-research-2cdc29780efb9a19cc7a520eed610b41.jpg";